import { PageInterface } from "@lg-cfa/types";
import { atom } from "recoil";

import { pagesArray } from "@consts";
import { persistAtom } from "@states/persist";

export const currentPageState = atom<PageInterface | undefined>({
    key: "currentPageState",
    default: undefined,
    effects_UNSTABLE: [persistAtom],
});

export const pagesState = atom<PageInterface[]>({
    key: "allPagesState",
    default: pagesArray,
});
